import type { BuildingSocietySavingsSettingsDetailsConfig } from '../../BuildingSocietySavingsSettingsDetailsConfig';

export const savingsSettingsDetails: BuildingSocietySavingsSettingsDetailsConfig = {
    displayIban: false,
    displaySlashedBBAN: false,
    displayBic: false,
    displayContractAmount: false,
    displayMonthlySavingsAmount: false,
    displayContractDate: false,
    displayExpirationDate: false,
    displayAgreementNumber: false,
};
